/**
 * Company: SPHMedia
 * Description: [Renders podcast component]
 */

import AudioPlayer from "@elements/Player/PodcastPlayer";
import { PodcastProcessedResponse } from "@hooks/transformer/usePodcastResponse";
import { Heading } from "@sphtech/sph-web-ui/elements/Heading";
import { ReactElement } from "react";

type MediaPodcastProps = {
  playing: PodcastProcessedResponse;
};

/**
 * Media content podcast
 * Description: [Podcast player for article infinite scroll]
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function MediaPodcast({
  playing,
}: MediaPodcastProps): ReactElement {
  return (
    <div className="flex flex-col gap-3">
      <div className="mt-4 lg:mt-6 w-full h-0.5 bg-brand-primary"></div>
      <Heading
        Element="h2"
        className="text-text-muted text-base font-bold leading-[150%]"
      >
        Podcast
      </Heading>
      <div className="-my-2">
        <AudioPlayer
          {...playing}
          height="200"
          showName={false}
          showDate={false}
        />
      </div>
    </div>
  );
}
